/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams } from "../models/UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup } from "../axios/usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryKey = (groupId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams["groupId"]) => ["users-authz-api", { url: '/admin/group/:groupId/permissions', params: {groupId:groupId} }] as const

export type UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryKey = ReturnType<typeof usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryKey>

export function usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryOptions(groupId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams["groupId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryKey(groupId)
  return queryOptions<UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, ResponseErrorConfig<Error>, UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, typeof queryKey>({
   enabled: !!(groupId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup(groupId, config)
   },
  })
}

/**
 * @summary Get all permissions for a specific group
 * {@link /admin/group/:groupId/permissions}
 */
export function useUsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup<TData = UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, TQueryData = UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, TQueryKey extends QueryKey = UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryKey>(groupId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupPathParams["groupId"], options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryKey(groupId)

  const query = useQuery({
   ...usersAuthzAPIAdminPermissionsReadGetPermissionsOfGroupQueryOptions(groupId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}